var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Injectable } from '@angular/core';
import { BaseProvider } from './base';
import { TranslateService } from '@ngx-translate/core';
/** In order to start displaying a countdown when the user has 30 days left, we need a grace period of approximately (but slightly less than) one day.
 * Otherwise, the user will only see the 30 day warning if they load at the moment where they have exactly 30 days left.
 */
export var LICENSE_EXPIRATION_MONTH = 1000 * 60 * 60 * 24 * 31 - 1;
var OnPremiseProvider = /** @class */ (function (_super) {
    __extends(OnPremiseProvider, _super);
    function OnPremiseProvider(translate) {
        var _this = _super.call(this) || this;
        _this.translate = translate;
        _this.isOnPremise = null;
        _this.ipc = null;
        if (_this.isOnPremiseElectronApp()) {
            // Load a subset of the ipcRenderer.
            // For security purposes, we should only expose the methods we're actually using in the codebase;
            // please see on-premise/www/preload.ts.
            _this.ipc = window.api.ipcRenderer;
        }
        return _this;
    }
    OnPremiseProvider.prototype.getBrainBankHostAddress = function () {
        return this.ipc.sendSync('get-brainbank-host-address');
    };
    OnPremiseProvider.prototype.healthcheck = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isOnPremiseElectronApp()) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.ipc.invoke('healthcheck')];
                    case 1:
                        result = _a.sent();
                        this.healthCheckStatus = {
                            sdkService: result.sdkService,
                            detectionService: result.detectionService,
                            brainBank: result.brainBank,
                            isGPU: result.isGPU,
                            cudaUpToDate: result.cudaUpToDate,
                            license: {
                                licenseStatus: result.license.licenseStatus,
                                licenseExpirationDate: result.license.licenseExpirationDate
                            },
                            features: {
                                classifierDataset: result.features.classifierDataset,
                                anomalyDataset: result.features.anomalyDataset,
                                detectorDataset: result.features.detectorDataset
                            }
                        };
                        return [3 /*break*/, 3];
                    case 2:
                        // return healthy status when running in cloud
                        this.healthCheckStatus = {
                            sdkService: true,
                            detectionService: true,
                            brainBank: true,
                            isGPU: true,
                            cudaUpToDate: undefined,
                            license: undefined,
                            features: {
                                classifierDataset: true,
                                anomalyDataset: true,
                                detectorDataset: true
                            }
                        };
                        _a.label = 3;
                    case 3: return [2 /*return*/, this.healthCheckStatus];
                }
            });
        });
    };
    OnPremiseProvider.prototype.getInspectorStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isOnPremiseElectronApp()) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.ipc.invoke('inspectorStatus')];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, {
                                isBusy: result.isBusy
                            }];
                    case 2: 
                    // return not busy when running in cloud
                    return [2 /*return*/, {
                            isBusy: false
                        }];
                }
            });
        });
    };
    OnPremiseProvider.prototype.getIsGPU = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.healthCheckStatus == undefined)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.healthcheck()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.isGPU];
                    case 2: return [2 /*return*/, this.healthCheckStatus.isGPU];
                }
            });
        });
    };
    OnPremiseProvider.prototype.getLicenseExpirationDate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.healthCheckStatus == undefined)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.healthcheck()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.license ? result.license.licenseExpirationDate : ''];
                    case 2: return [2 /*return*/, this.healthCheckStatus.license ? this.healthCheckStatus.license.licenseExpirationDate : ''];
                }
            });
        });
    };
    OnPremiseProvider.prototype.getLicensedFeatures = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.healthCheckStatus == undefined)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.healthcheck()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.features];
                    case 2: return [2 /*return*/, this.healthCheckStatus.features];
                }
            });
        });
    };
    OnPremiseProvider.prototype.subscribeForHealthCheck = function (listener) {
        if (this.isOnPremiseElectronApp()) {
            this.ipc.on("healthcheck", function (event, status) {
                listener(status);
            });
        }
    };
    OnPremiseProvider.prototype.subscribeForInspectorStatus = function (listener) {
        if (this.isOnPremiseElectronApp()) {
            this.ipc.on('inspectorStatus', function (event, status) {
                listener(status);
            });
        }
    };
    OnPremiseProvider.prototype.isOnPremiseElectronApp = function () {
        if (this.isOnPremise != null) {
            return this.isOnPremise;
        }
        if (navigator && navigator.userAgent && navigator.userAgent.toLowerCase().indexOf('electron') >= 0) {
            this.isOnPremise = true;
        }
        else {
            this.isOnPremise = false;
        }
        return this.isOnPremise;
    };
    OnPremiseProvider.prototype.getWheatleyToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.ipc.invoke('get-wheatley-token')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    OnPremiseProvider.prototype.openLinkInExternalBrowser = function (link) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.ipc.invoke('open-link-in-external-browser', link)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    OnPremiseProvider.prototype.setWheatleyToken = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.ipc.invoke('set-wheatley-token', value)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    OnPremiseProvider.prototype.deleteWheatleyToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.ipc.invoke('delete-wheatley-token')];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    OnPremiseProvider.prototype.downloadUrl = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.ipc.invoke('download-url', url)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    OnPremiseProvider.prototype.getAppVersion = function () {
        return this.isOnPremiseElectronApp() ? this.ipc.sendSync('get-app-version') : '1.0.0';
    };
    OnPremiseProvider.prototype.getDownloadPath = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.ipc.invoke('get-download-path')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    OnPremiseProvider.prototype.archiveLogs = function (downloadPath) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.ipc.invoke('export-logs', downloadPath)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    OnPremiseProvider.prototype.maximize = function () {
        return this.ipc.sendSync('app-header-action-maximize');
    };
    OnPremiseProvider.prototype.minimize = function () {
        return this.ipc.sendSync('app-header-action-minimize');
    };
    OnPremiseProvider.prototype.close = function () {
        return this.ipc.sendSync('app-header-action-close');
    };
    OnPremiseProvider.prototype.isLicenseExpiringSoon = function (licenseExpirationDate) {
        var expirationDate = new Date(licenseExpirationDate).getTime();
        var currentDate = new Date().getTime();
        return expirationDate - currentDate <= LICENSE_EXPIRATION_MONTH;
    };
    OnPremiseProvider.prototype.getCountdownText = function (expirationDate) {
        if (expirationDate !== '') {
            var timeLeft = new Date(expirationDate).getTime() - new Date().getTime();
            var daysLeft = Math.floor(timeLeft / (86400 * 1000));
            if (daysLeft <= 1) {
                return this.translate.instant('Your VIA license is set to expire in <strong>1 day</strong>.');
            }
            else {
                return this.translate.instant('Your VIA license is set to expire in <strong>[[daysLeft]] days</strong>.', { daysLeft: daysLeft });
            }
        }
        return '';
    };
    OnPremiseProvider = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [TranslateService])
    ], OnPremiseProvider);
    return OnPremiseProvider;
}(BaseProvider));
export { OnPremiseProvider };
//# sourceMappingURL=on-premise.js.map


// WEBPACK FOOTER //
// ./src/providers/on-premise.ts.pre-build-optimizer.js